import {
  Component,
  ViewEncapsulation,
  inject,
  signal,
  DestroyRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  OnlineStatusService,
  OnlineStatusType
} from 'ngx-online-status';
import { SideNav } from './side-nav/side-nav';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'isc-layout',
  imports: [SideNav, RouterModule],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
})
export class Layout {

  // ✅ DI using inject
  private readonly onlineStatusService = inject(OnlineStatusService);
  private readonly destroyRef = inject(DestroyRef);

  // ✅ state as signals
  readonly year = signal(new Date().getFullYear());
  readonly showConnection = signal(false);
  readonly isAppOnline = signal<OnlineStatusType>(
    this.onlineStatusService.getStatus()
  );

  constructor() {
    this.listenNetworkStatus();
  }

  // ✅ reactive network listener
  private listenNetworkStatus() {
    this.onlineStatusService.status
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((status: OnlineStatusType) => {

        if (status !== this.isAppOnline()) {
          this.showConnection.set(true);

          // auto-hide after 3s (only when online)
          setTimeout(() => {
            if (this.isAppOnline() === OnlineStatusType.ONLINE) {
              this.showConnection.set(false);
            }
          }, 3000);
        }

        this.isAppOnline.set(status);
      });
  }
}